import { Component } from '@angular/core';
import { ListPhaseModelComponent } from '../employees/list-phase-model/list-phase-model';

@Component({
  selector: 'app-admin-phase-models',
  standalone: true,
  imports: [ListPhaseModelComponent],
  templateUrl: './phase-models-view.html'
})
export class AdminPhaseModelsView {}
